/**
 * Up to two initials from a full name: "Анна Шевченко" -> "АШ".
 *
 * Shared by the Avatar fallback and the client-base bubbles, which used to
 * store precomputed initials next to the name and drift when the name changed.
 */
export const initialsOf = (name: string): string =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('');
